import { NgModule } from '@angular/core';
import { SupportRoutingModule } from './support-routing.module';

@NgModule({
    imports: [SupportRoutingModule]
})
export class SupportModule {}
